import { BulkDomainSearchViewModel } from '@orderForm/view-models'
import { BulkDomainSearchSelectedTldView } from './selected-tld.view'

export class BulkDomainSearchSelectedTldListView {
  private el: HTMLElement
  private viewModel: BulkDomainSearchViewModel
  private callbacks: (() => void)[] = []

  constructor(el: HTMLElement, viewModel: BulkDomainSearchViewModel) {
    this.el = el
    this.viewModel = viewModel

    const observer = new MutationObserver((list) => {
      this.dispatchMutation(list)
    })

    const existingTldEls = this.el.querySelectorAll<HTMLAnchorElement>(
      '.js-domain-search__bulk-tld:is(.clone)'
    )

    Array.from(existingTldEls)
      .map((tldEl) => {
        new BulkDomainSearchSelectedTldView(tldEl, this)
        return tldEl.dataset.tld
      })
      .forEach((tld) => {
        if (tld) {
          this.viewModel.addTld(tld)
        }
      })

    observer.observe(el, {
      characterData: false,
      childList: true,
      attributes: false
    })
  }

  private dispatchMutation(changes: MutationRecord[]): void {
    changes.forEach((change) => {
      const { addedNodes } = change
      addedNodes.forEach((node) => {
        const el = node as HTMLElement
        new BulkDomainSearchSelectedTldView(el, this)
      })
      this.callbacks.forEach((callback) => callback())
    })
  }

  private getTldTemplate(): HTMLAnchorElement {
    const template = this.el.querySelector<HTMLAnchorElement>(
      '.js-domain-search__bulk-tld:not(.clone)'
    )

    if (!template) {
      throw new Error(
        'BulkDomainSearchSelectedTldListView: Selected Tld Template is null'
      )
    }

    const clone = <HTMLAnchorElement>template.cloneNode(true)

    // Mark as clone
    clone.classList.add('clone')

    // Remove display none
    clone.style.display = 'block'

    return clone
  }

  public appendTld(tld: string): void {
    if (!this.viewModel.containsTld(tld)) {
      const template = this.getTldTemplate()
      template.textContent = `.${tld}`
      template.dataset.tld = tld
      this.el.appendChild(template)
      this.viewModel.addTld(tld)
    }
  }

  public removeTld(tld: string): void {
    if (this.viewModel.containsTld(tld)) {
      const elToDelete = <HTMLElement | undefined>Array.from(
        this.el.children
      ).find((_child) => {
        const child = <HTMLElement>_child
        return child.classList.contains('clone') && child.dataset.tld === tld
      })

      if (elToDelete) {
        this.el.removeChild(elToDelete)
        this.viewModel.removeTld(tld)
      }
    }
  }

  public onListChange(callback: () => void): void {
    this.callbacks.push(callback)
  }
}
